<template>
  <div>
    <brand-filters
      :id.sync="payload.id"
      :name.sync="payload.name"
      @apply="getBrands(payload)"
    />
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="4">
      <v-app-bar flat elevation="0" dense color="transparent">
        <v-toolbar-title> <h4>Brands</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0" v-if="!loading">
        <template>
          <v-data-table
            :headers="headers"
            :items="brands"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.rowsPerPageItems"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            @click:row="edit($event.id)"
            class="elevation-0"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.logo="{ item }">
              <v-avatar>
                <img :src="item.logo" alt="John" />
              </v-avatar>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item link>
                    <v-list-item-title @click="edit(item.id)"
                      >Edit</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Helpers from "@/mixins/helpers";
import BrandFilters from "./BrandFilters.vue";
// eslint max-nested-callbacks: ["error", 10]

export default {
  components: {
    BrandFilters
  },
  mixins: [Helpers],
  data() {
    return {
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "logo"
        },
        {
          text: "Id",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "",
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      payload: {
        from: 0,
        to: 10,
        id: null,
        name: null
      }
    };
  },
  computed: {
    brands() {
      return this.$store.state.brands.brands;
    },
    totalItems() {
      return this.$store.state.brands.totalBrands;
    }
  },
  created() {
    this.getBrands(this.payload);
  },
  methods: {
    getBrands(payload) {
      this.$store
        .dispatch("brands/LOAD_BRANDS", payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      this.payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage;
      this.payload.to =
        pagination.itemsPerPage === -1
          ? this.totalItems
          : pagination.itemsPerPage;
      this.getBrands(this.payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        this.payload.from =
          this.pagination.page * this.pagination.itemsPerPage -
          this.pagination.itemsPerPage;
        this.payload.to =
          this.pagination.itemsPerPage === -1
            ? this.totalItems
            : this.pagination.itemsPerPage;
        this.getBrands(this.payload);
      }
    }
  }
};
</script>
